/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_No_Associated_JobInputs */

const en_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No associated job`)
};

const de_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine zugehörige Stelle`)
};

const fr_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun emploi associé`)
};

const es_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin empleo asociado`)
};

const it_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun lavoro associato`)
};

const nl_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen gekoppelde baan`)
};

const pl_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak powiązanej oferty pracy`)
};

const fi_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei liitettyä työpaikkaa`)
};

const da_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intet tilknyttet job`)
};

const sv_cover_letters_no_associated_job = /** @type {(inputs: Cover_Letters_No_Associated_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget kopplat jobb`)
};

/**
* | output |
* | --- |
* | "No associated job" |
*
* @param {Cover_Letters_No_Associated_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_no_associated_job = /** @type {((inputs?: Cover_Letters_No_Associated_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_No_Associated_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_no_associated_job(inputs)
	if (locale === "fr") return fr_cover_letters_no_associated_job(inputs)
	if (locale === "es") return es_cover_letters_no_associated_job(inputs)
	if (locale === "it") return it_cover_letters_no_associated_job(inputs)
	if (locale === "nl") return nl_cover_letters_no_associated_job(inputs)
	if (locale === "pl") return pl_cover_letters_no_associated_job(inputs)
	if (locale === "fi") return fi_cover_letters_no_associated_job(inputs)
	if (locale === "da") return da_cover_letters_no_associated_job(inputs)
	if (locale === "sv") return sv_cover_letters_no_associated_job(inputs)
	return en_cover_letters_no_associated_job(inputs)
});